import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { RestoreFocusDirective } from "src/app/shared/modules/directives/restore-focus.directive";
import { ScrollableDirective } from "src/app/shared/modules/directives/scrollable.directive";
import { PrimeTemplate } from 'primeng/api';
import { AutoFocusIfDirective } from "../../directives/auto-focus.directive";

@Component({
  selector: 'app-dialog',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [Dialog, RestoreFocusDirective, ScrollableDirective, PrimeTemplate, AutoFocusIfDirective]
})
export class DialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() header: string | undefined;
  @Input() closable = true;
  @Input() resizable = false;
  @Input() draggable = false;
  @Input() showHeader = true;
  @Input() modal = true;
  @Input() closeAriaLabel = 'Close';
  @Input() blockScroll = true;
  @Input() closeOnEscape = true;
  @Input() styleClass: string | undefined;
  @Input() contentStyleClass: string | undefined;

  @Input() appRestoreFocus: string | null = null;
  @Input() appRestoreFocusOnHide = false;

  @Output() onShow = new EventEmitter<any>();
  @Output() onHide = new EventEmitter<any>();

  @ViewChild(Dialog) private dialogRef!: Dialog;

  @ViewChild(RestoreFocusDirective) private restoreFocusDir?: RestoreFocusDirective;

  restore(): void {
    this.restoreFocusDir?.restore();
  }

  get ariaLabelledBy(): string | null {
    return this.dialogRef?.ariaLabelledBy ?? null;
  }

  onVisibleChange(value: boolean): void {
    this.visible = value;
    this.visibleChange.emit(value);
  }
}
